<template>
  <div class="myWallet">
    <div class="header" v-if="currencyList && currencyList.length > 0">
      <van-row class="currency-row">
        <van-col span="6"></van-col>
        <van-col span="6" v-for="(currency, index) in currencyList" :key="index">{{
          currency.CurrencySn
        }}</van-col>
      </van-row>
      <van-row class="amount-row">
        <van-col span="6">{{ $t.myWallet.accountBalance }}</van-col>
        <van-col span="6" v-for="(amount, index) in currencyList" :key="index">{{
          amount.TotalAmount
        }}</van-col>
      </van-row>
      <van-row class="amount-row">
        <van-col span="6">{{ $t.myWallet.processAccountBalance }}</van-col>
        <van-col span="6" v-for="(amount, index) in currencyList" :key="index">{{
          amount.FrozenAmount
        }}</van-col>
      </van-row>
    </div>

    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="$t.meta.input"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      swipeable
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
        :disabled="loading ? true : false"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList(page + 1)"
        >
          <div
            :class="menuState == 2 ? 'detail' : 'list-container'"
            v-for="(item, index) in tableData"
            :key="index"
          >
            <template v-if="menuState == 2">
              <div @click="gotoPayBillList(item.FundType, item.SystemOperationNumber)">
                <div class="left">
                  <div class="fundType">
                    <span v-if="item.FundType == 1">{{ $t.myWallet.fundType1 }}</span>
                    <span v-if="item.FundType == 2">{{ $t.myWallet.fundType2 }}</span>
                    <span v-if="item.FundType == 3">{{ $t.myWallet.fundType3 }}</span>
                    <span v-if="item.FundType == 4">{{ $t.myWallet.fundType4 }}</span>
                  </div>
                  <div class="flowDate">{{ item.FlowDate }}</div>
                </div>
                <div class="right">
                  <div
                    :class="[
                      'bookAmount',
                      item.FundType == 1 || item.FundType == 3 ? 'green' : 'red',
                    ]"
                  >
                    <span v-if="item.BookkeepingAmountStr">{{
                      item.BookkeepingAmountStr
                    }}</span>
                    <span v-else>{{ item.BookkeepingAmount }}</span>
                  </div>
                  <div class="bookBalance">
                    {{ item.CurrencySn }} {{ $t.myWallet.balance }}：{{
                      item.BookkeepingAccountBalanceStr
                    }}
                  </div>
                </div>
                <div class="arrow">
                  <van-icon name="arrow" v-if="item.FundType == 2" />
                </div>
              </div>
            </template>
            <template v-else>
              <div class="list-item">
                {{ $t.myWallet.tradeNumber }}：{{ item.PaymentInquiryNumber }}
              </div>
              <div class="list-item">
                {{ $t.myWallet.paymentMethod }}：
                <span v-if="item.PaymentMethod == 1">{{ $t.myWallet.payment1 }}</span>
                <span v-if="item.PaymentMethod == 2">{{ $t.myWallet.payment2 }}</span>
                <span v-if="item.PaymentMethod == 4">{{ $t.myWallet.payment4 }}</span>
              </div>
              <div class="list-item">
                {{ $t.myWallet.tradeCurrency }}：{{ item.CurrencySn }}
              </div>
              <div class="list-item">
                {{ $t.myWallet.rechargeAmount }}：{{ item.RemittanceAmount }}
              </div>
              <div class="list-item">
                {{ $t.myWallet.rechargeTime }}：{{ item.CreateTime }}
              </div>
              <div class="list-item">
                {{ $t.myWallet.orderState }}：
                <span v-if="item.OrderState == 0">{{ $t.myWallet.pState1 }}</span>
                <span v-if="item.OrderState == 1">{{ $t.myWallet.pState2 }}</span>
                <span v-if="item.OrderState == 2">{{ $t.myWallet.pState3 }}</span>
              </div>
              <div class="list-item">
                {{ $t.myWallet.entryState }}：
                <span v-if="item.EntryState == 0">{{ $t.myWallet.eState1 }}</span>
                <span v-if="item.EntryState == 1">{{ $t.myWallet.eState2 }}</span>
                <span v-if="item.EntryState == 2">{{ $t.myWallet.eState3 }}</span>
              </div>
              <div class="buttons">
                <van-button
                  class="primary-btn"
                  size="small"
                  type="primary"
                  @click="gotoMyWalletRechange(item.CEId)"
                  >{{ $t.myWallet.listButton }}
                </van-button>
              </div>
            </template>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <template v-if="menuState == 1">
          <div class="radio-label">{{ $t.myWallet.paymentMethod }}</div>
          <van-radio-group v-model="paymentMethod" direction="horizontal">
            <van-radio :name="1">{{ $t.myWallet.payment1 }}</van-radio>
            <van-radio :name="2">{{ $t.myWallet.payment2 }}</van-radio>
            <van-radio :name="4">{{ $t.myWallet.payment4 }}</van-radio>
          </van-radio-group>

          <div class="radio-label">{{ $t.myWallet.orderState }}</div>
          <van-radio-group v-model="orderState" direction="horizontal">
            <van-radio :name="0">{{ $t.myWallet.pState1 }}</van-radio>
            <van-radio :name="1">{{ $t.myWallet.pState2 }}</van-radio>
            <van-radio :name="2">{{ $t.myWallet.pState3 }}</van-radio>
          </van-radio-group>

          <div class="radio-label">{{ $t.myWallet.entryState }}</div>
          <van-radio-group v-model="entryState" direction="horizontal">
            <van-radio :name="0">{{ $t.myWallet.eState1 }}</van-radio>
            <van-radio :name="1">{{ $t.myWallet.eState2 }}</van-radio>
            <van-radio :name="2">{{ $t.myWallet.eState3 }}</van-radio>
          </van-radio-group>

          <div class="custom-date">
            <div class="date-label">{{ $t.meta.date }}</div>
            <van-button
              class="date-btn1"
              type="info"
              size="small"
              @click="showStartDate"
              >{{ $t.meta.beginDate }}</van-button
            >
            <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
              $t.meta.endDate
            }}</van-button>
            <div class="date-txt" v-if="beginTime || endTime">
              {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
            </div>
          </div>
        </template>

        <template v-if="menuState == 2">
          <div class="radio-label">{{ $t.myWallet.fundTypeStr }}</div>
          <van-radio-group v-model="fundType" direction="horizontal">
            <van-radio name="1">{{ $t.myWallet.fundType1 }}</van-radio>
            <van-radio name="2">{{ $t.myWallet.fundType2 }}</van-radio>
            <van-radio name="3">{{ $t.myWallet.fundType3 }}</van-radio>
            <van-radio name="4">{{ $t.myWallet.fundType4 }}</van-radio>
          </van-radio-group>

          <div class="radio-label">{{ $t.meta.currency }}</div>
          <van-radio-group v-model="currency" direction="horizontal">
            <van-radio
              v-for="(currency, index) in currencyList"
              :key="index"
              :name="currency.SCId"
              >{{ currency.CurrencySn }}</van-radio
            >
          </van-radio-group>
        </template>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoMyWalletRechange(null)">{{
        $t.myWallet.rechangeButton
      }}</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Col,
  Row,
  List,
  Search,
  Popup,
  Form,
  Button,
  Radio,
  RadioGroup,
  Icon,
  Tab,
  Tabs,
  Picker,
  DatetimePicker,
} from "vant";

Vue.use(Col)
  .use(Row)
  .use(List)
  .use(Search)
  .use(Popup)
  .use(Form)
  .use(Button)
  .use(Radio)
  .use(RadioGroup)
  .use(Icon)
  .use(Tab)
  .use(Tabs)
  .use(Picker)
  .use(DatetimePicker);

export default {
  name: "myWallet",
  data() {
    return {
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [
        {
          title: this.$t.myWallet.tab1,
          name: 1,
          count: 0,
        },
        {
          title: this.$t.myWallet.tab2,
          name: 2,
          count: 0,
        },
      ],
      currencyList: {},
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //筛选
      orderBy: "",
      searchText: "",
      //1
      entryState: null,
      orderState: 1,
      paymentMethod: null,
      //2
      fundType: null,
      currency: null,
      showFilter: false,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList(1);
    },
  },
  methods: {
    gotoMyWalletRechange(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "myWalletRechange",
        name: "myWalletRechange",
        query: [
          {
            name: "CEId",
            value: id,
          },
        ],
      });
    },
    gotoPayBillList(type, id) {
      if (type == 2) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: true,
          path: "paybillList",
          name: "paybillList",
          query: [
            {
              name: "NuclearAccountNo",
              value: id,
            },
          ],
        });
      }
    },
    isFilter() {
      if (
        this.fundType ||
        this.currency ||
        this.paymentMethod ||
        this.entryState ||
        (this.beginTime && this.endTime)
      ) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.fundType = null;
      this.currency = null;
      this.paymentMethod = null;
      this.orderState = 1;
      this.entryState = null;
      this.beginTime = "";
      this.endTime = "";
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    getList(page) {
      return new Promise((resolve) => {
        var param = {
          PageIndex: page,
          PageSize: this.pageSize,
        };
        var request = null;
        if (this.menuState == 2) {
          param.IsEliminateWriteOffRecords = 1;
          param.FundType = this.fundType;
          param.SCId = this.currency;
          request = this.$api.myWallet.getCustomerFundUseDetailAndAvailableFundList(
            param
          );
        } else {
          param.PaymentMethod = this.paymentMethod;
          param.OrderState = this.orderState;
          param.EntryState = this.entryState;
          param.BeginTime = this.beginTime;
          param.EndTime = this.endTime;
          request = this.$api.myWallet.getCustomerRechargeRecordsListByPage(param);
        }
        request
          .then((res) => {
            this.currencyList = res.data.AvailableFundList;
            if (this.menuState == 2) {
              var detail = res.data.UseDetailList;
              this.tableData = this.tableData.concat(detail.Data);
            } else {
              var detail = res.data.CustomerRechargeRecordList;
              this.tableData = this.tableData.concat(detail.Data);
            }
            this.loading = false;
            this.error = false;
            this.errorText = "";

            this.page = detail.PageIndexs;
            this.finished = this.page >= detail.ALLPages;
            resolve(true);
          })
          .catch((error) => {
            this.loading = false;
            this.error = true;
            this.errorText = error.message;
          });
      });
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.myWallet {
  .header {
    padding: 10px;
    font-size: 14px;
    border-bottom: 1px solid #e5e5e5;
    .currency-row {
      background: #009ed4;
      color: white;
      .van-col {
        padding-left: 10px;
        line-height: 35px;
      }
    }
    .amount-row {
      .van-col {
        padding-left: 10px;
        line-height: 35px;
      }
    }
  }
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #e5e5e5;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    bottom: calc(0px + env(safe-area-inset-bottom));
    width: 100%;
    text-align: center;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .van-pull-refresh {
    overflow: unset;
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
    .detail {
      padding: 2.5% 0% 2.5% 5%;
      border-bottom: 1px solid #e5e5e5;
      .left {
        vertical-align: middle;
        display: inline-block;
        width: 55%;
        .fundType {
          color: #333;
          font-size: 16px;
          margin-bottom: 10px;
        }
        .flowDate {
          color: #999;
          font-size: 12px;
        }
      }
      .right {
        text-align: right;
        vertical-align: top;
        display: inline-block;
        width: 40%;
        .bookAmount {
          color: #333;
          font-size: 16px;
          margin-bottom: 10px;
        }
        .green {
          color: green;
        }
        .red {
          color: red;
        }
        .bookBalance {
          color: #666;
          font-size: 12px;
        }
      }
      .arrow {
        text-align: center;
        vertical-align: middle;
        display: inline-block;
        width: 5%;
        .van-icon {
          font-size: 10px;
          font-weight: bold;
          color: #999;
        }
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
